// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3qzTI","left":"StickyBox_left__16fMO","right":"StickyBox_right__II07H"};